import React, { useEffect, useState, useCallback } from "react";
import "./Total.css";
import StockWidget from "./StockWidget";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");
const backend = await new Backend().init();

export default function Total({
  supers,
  master,
  user,
  broker,
  tbuy,
  tsell,
  turnover,
  userType,
  handleOpenModal
}) {
  const [indexList, setIndexList] = useState([]);
  const [loading, setLoading] = useState(false);

  /** ✅ Safe number formatting */
  const formatNum = (val, decimals = 0) => {
    const num = parseFloat(val);
    if (isNaN(num)) return "0";
    return fmt.format(num.toFixed(decimals));
  };

  /** ✅ Load market index data */
  const fetchIndexes = useCallback(() => {
    setLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    backend.index(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setIndexList(r.index || []);
      } else {
        toast.error(r.message);
      }
    });
  }, []);

  useEffect(() => {
    fetchIndexes();
  }, [fetchIndexes]);

  return (
    <div className="total-screen">
      {/* 🔹 Top summary cards */}
      <div className="total-summary">
        {userType === 1 && (
          <div onClick={handleOpenModal} className="market-box primarywidget">
            <span className="market-label">SUPER</span>
            <span className="market-value">{formatNum(supers)}</span>
          </div>
        )}
        {(userType === 1 || userType === 2) && (
          <div className="market-box primarywidget">
            <span className="market-label">MASTER</span>
            <span className="market-value">{formatNum(master)}</span>
          </div>
        )}
        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
          <div className="market-box primarywidget">
            <span className="market-label">USER</span>
            <span className="market-value">{formatNum(user)}</span>
          </div>
        )}
        {(userType === 1 || userType === 2 || userType === 3) && (
          <div className="market-box primarywidget">
            <span className="market-label">BROKER</span>
            <span className="market-value">{formatNum(broker)}</span>
          </div>
        )}

        <div className="stock-grid">
          {loading ? (
            <div className="loading-text">Loading market data...</div>
          ) : indexList.length > 0 ? (
            indexList.map((item, idx) => <StockWidget key={idx} item={item} />)
          ) : (
            <div className="no-stocks">No Stocks Available</div>
          )}
        </div>
      </div>

      {/* 🔹 Index Widgets */}

      {/* 🔹 Turnover summary */}
      {/* <div className="turnover-bar">
        <div className="turnover-item buy">
          <span className="label">BUY</span>
          <span className="value">{formatNum(tbuy)}</span>
        </div>
        <div className="turnover-item sell">
          <span className="label">SELL</span>
          <span className="value">{formatNum(tsell)}</span>
        </div>
        <div className="turnover-item total">
          <span className="label">TURNOVER</span>
          <span className="value">{formatNum(turnover)}</span>
        </div>
      </div> */}
    </div>
  );
}
